<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a href="/" class="logo logo-dark">
          <span class="logo-sm"> F </span>
          <span class="logo-lg"> FIRST-STEP </span>
        </a>

        <a href="/" class="logo logo-light">
          <span class="logo-sm"> F </span>
          <span class="logo-lg"> FIRST-STEP </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item" id="vertical-menu-btn" (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>
    </div>

    <div class="d-flex">
      <div class="dropdown d-none d-lg-inline-block ml-1">
        <button type="button" class="btn header-item noti-icon" data-toggle="fullscreen" (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>

      <div class="dropdown d-inline-block">
        <button type="button" class="btn header-item noti-icon" id="page-header-notifications-dropdown" (click)="goManagerAlarm()">
          <i class="bx bx-bell" [ngClass]="{ 'bx-tada': badgeCount > 0 }"></i>
          <span class="badge badge-danger badge-pill" *ngIf="badgeCount > 0">{{ badgeCount }}</span>
        </button>
      </div>

      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item" ngbDropdownToggle id="page-header-user-dropdown">
          <span class="d-none d-xl-inline-block ml-1">관리자</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
          <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()"
            ><i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i> {{ 'HEADER.LOGIN.LOGOUT' | translate }}</a
          >
        </div>
      </div>
    </div>
  </div>
</header>
